import React from "react";
import { Typography } from "@mui/material";
import errorMessageStyle from "./errorMessageStyle";

interface ErrorMessageProps {
  message: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  return (
    <Typography
      sx={errorMessageStyle.typography}
      dangerouslySetInnerHTML={{ __html: message }}
      >
    </Typography>
  );
};

export default ErrorMessage;